import { i18n } from '@js/i18n'

export default {
  form: {
    residenceCountry: '',
    residenceCity: '',
    residenceAddress: '',
    residenceZipCode: ''
  },
  rows: [
    [
      {
        "heading": i18n.kyc_submit_residence_address()
      }
    ],
    [
      {
        "model": "residenceCountry",
        "name": "residence-country",
        "id":  "kyc-residence-country",
        "label": i18n.lbl_country(),
        "field": "select",
        "required": true,
        "values": "countries",
        "validate": "required"
      }
    ],
    [
      {
        "model": "residenceCity",
        "name": "residence-city",
        "id":  "kyc-residence-city",
        "label": i18n.lbl_city(),
        "field": "text",
        "required": true,
        "validate": "required"
      }
    ],
    [
      {
        "model": "residenceAddress",
        "name": "residence-address",
        "id":  "kyc-residence-address",
        "required": true,
        "label": i18n.lbl_street_name(),
        "field": "text",
        "validate": "required|max:45"
      }
    ],
    [
      {
        "model": "residenceZipCode",
        "name": "residence-zip-code",
        "id":  "kyc-residence-zip-code",
        "label": i18n.lbl_zip_code(),
        "field": "text",
        "required": true,
        "validate": "required|max:20"
      }
    ]
  ]
}



// WEBPACK FOOTER //
// ./src/vue/app/verification/spec/syndicate/step-5.residence.schema.js